<template>
  <div class="responsibility">
    <div class="bility-header">
      <topHeader
        :leftSrc="leftSrc"
        :label="label"
        :textColor="textColor"
        :backgroundColor="backgroundColor"
      ></topHeader>
    </div>
    <div class="bility-menu">
      <scrollList
        :menuList="menuList"
        :textColor="scrollColor"
        :backgroundColor="backgroundColor"
        :active="Number(this.$store.getters.menuActive)"
        @getchoose="getNewRoleList"
      ></scrollList>
    </div>
    <div class="bility-select">
      <!-- <div class="bility-lable">内部搜索：</div> -->
      <div class="bility-select-box">
        <div class="bility-input bility-input-depart" @click="opSelect = !opSelect">
          <input type="text" v-model="deptName" placeholder="请选择部门" />
        </div>
        <picker
          v-show="opSelect"
          :liList="liList"
          @closepicker="opSelect = !opSelect"
          @getPicker="getPicker"
        ></picker>
        <div class="bility-input">
          <input type="text" v-model="keyword" placeholder="请输入事项关键字" />
        </div>
        <div class="bility-btn">
          <img src="./../../assets/ico-sousuo@2x.png" @click="getListByWhere()" />
          <!-- <a href="javascript:void(0)" @click="getListByWhere()">查询</a> -->
        </div>
      </div>
    </div>
    <!-- <div class="bility-select">
      <div class="bility-select" @click="opSelect = !opSelect">
        <input type="text" v-model="deptName" placeholder="请选择部门" />
      </div>
      <picker
        v-show="opSelect"
        :liList="liList"
        @closepicker="opSelect = !opSelect"
        @getPicker="getPicker"
      ></picker>
    </div>-->
    <div class="bility-list">
      <backList :rolesList="rolesList" @getnewlist="getNewList"></backList>
    </div>
  </div>
</template>

<script>
import topHeader from "@/components/header.vue";
import scrollList from "@/components/scrollList.vue";
import backList from "@/components/backList.vue";
import picker from "@/components/picker.vue";
export default {
  data() {
    return {
      label: "权责清单列表",
      backgroundColor: "#ffffff",
      textColor: "#333333",
      scrollColor: "#666666",
      leftSrc: require("@/assets/ico@2x.png"),
      affairTypeId: Number(this.$store.getters.menuActive),
      keyword: "",
      page: 1,
      deptId: -1,
      deptName: "",
      opSelect: false,
      liList: [],
      rolesList: [],
      menuList: [],
      total: 0,
      flag: false //ture 数组追加 false 数组重置
    };
  },
  components: {
    topHeader,
    scrollList,
    backList,
    picker
  },
  mounted() {
    if (!!this.$route.query.depId && !!this.$route.query.deptName) {
      this.deptId = this.$route.query.depId;
      this.deptName = this.$route.query.deptName;
    }
    this.getListByWhere();
    this.getUnits();
    this.getTypeList();
  },
  methods: {
    getNewList() {
      if (this.rolesList.length < this.total) {
        this.page++;
        this.flag = true;
        this.getListByWhere();
      } else {
        this.rolesList = this.rolesList.concat([]);
      }
    },
    getNewRoleList(value) {
      this.affairTypeId = value;
      this.page = 1;
      this.flag = false;
      this.$store.commit("home/setMenuActive", value);
      this.getListByWhere();
    },
    getListByWhere() {
      this.$axios({
        url: "api/getListByWhere",
        type: "get",
        params: {
          areacode: "00",
          page: this.page,
          pageSize: 10,
          deptId: this.deptId,
          affairTypeId: this.affairTypeId,
          keyword: this.keyword
        }
      })
        .then(res => {
          this.total = res.data.totalCount;
          if (this.flag) {
            this.rolesList = this.rolesList.concat(res.data.parentList);
          } else {
            this.rolesList = res.data.parentList;
          }
          this.flag = false;
        })
        .catch(err => {
          console.info(err);
        });
    },
    getUnits() {
      this.$axios({
        url: "api/getDeptList",
        type: "get",
        params: {
          areacode: "00"
        }
      })
        .then(res => {
          this.liList = res.data.deptList;
        })
        .catch(err => {
          console.info(err);
        });
    },
    closePicker() {
      this.opSelect = !this.opSelect;
    },
    getPicker(value) {
      this.opSelect = false;
      this.deptName = value.Name;
      this.deptId = value.Id;
      this.page = 1;
      this.getListByWhere();
    },
    getTypeList() {
      this.$axios({
        url: "api/getTypeList",
        method: "get",
        params: {
          areacode: "00"
        }
      })
        .then(res => {
          this.menuList = res.data.typeList;
        })
        .catch(err => {
          console.info(err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.responsibility {
  width: 100%;
  height: 100vh;
  background-color: #ffffff;
  .bility-header {
    width: 100%;
    height: auto;
  }
  .bility-menu {
    width: 100%;
    height: auto;
  }
  .bility-select {
    width: 100%;
    height: 2rem;
    line-height: 2rem;
    padding: 0 1rem;
    .bility-select-box {
      width: 100%;
      height: 100%;
      display: flex;
      border: 1px solid #e22519;
      border-radius: 0.16rem;
      .bility-lable {
        width: 100%;
        height: 2rem;
        flex: 2;
        font-size: 0.8rem;
        position: relative;
        z-index: 99;
        min-width: 5rem;
      }
      .bility-input {
        width: 100%;
        height: 2rem;
        flex: 3;
        // padding: 0.25rem;
        input {
          width: 100%;
          height: 2rem;
          line-height: 2rem;
          display: block;
          // border: 0;
          border: 0px;
          background-color: transparent;
          outline: none;
          padding-left: 0.5rem;
          color: "#6B6B6B";
          font-size: 0.8rem;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }

      .bility-input-depart {
        max-width: 5rem;
        min-width: 5rem;
        width: 5rem;
        position: relative;
        &::after {
          content: "";
          width: 0;
          height: 0;
          position: absolute;
          top: 0;
          right: -0.25rem;
          bottom: 0;
          margin: auto;
          border: 0.35rem solid;
          border-color: #e0e0e0 transparent transparent transparent;
          transform: translateY(25%);
          z-index: 50;
        }
      }
      .bility-btn {
        width: 100%;
        height: 2rem;
        min-width: 1.5rem;
        max-width: 1.5rem;
        flex: 1;
        img {
          width: 0.8rem;
          height: 0.8rem;
        }
        // a {
        //   border: 1px solid #e0e0e0;
        //   padding: 0.25rem;
        //   font-size: 0.7rem;
        //   text-decoration: none;
        //   border-radius: 0.5rem;
        // }
      }
    }
    // .bility-select {
    //   width: 100%;
    //   height: 2rem;
    //   flex: 5;
    //   padding: 0.25rem 0;
    //   p {
    //     width: 100%;
    //     height: 1.5rem;
    //     border: 1px solid #e0e0e0;
    //     background-color: transparent;
    //     text-align: left;
    //     font-size: 0.7rem;
    //     line-height: 1.5rem;
    //     padding-left: 0.5rem;
    //   }
    // }
  }
  .bility-list {
    width: 100%;
    height: auto;
    overflow: hidden;
  }
}
</style>